module.exports = __webpack_public_path__ + "static/media/hero03.56167cf5.jpg";